import * as React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import {
    Panel,
    Button,
    Form,
    FormGroup,
    ControlLabel,
    FormControl,
    Checkbox,
    HelpBlock
} from 'react-bootstrap';
import DateTime from 'react-datetime';
import * as actions from './actions/ImageProcessingActions';
import notify from '../../../../shared/feedback/notifications';
import { Translate } from '../../../../shared/LanguageService';
import * as PhotoStatus from '../../../../shared/PhotoStatus';
import { handleError } from '../../../../shared/ErrorCatching';
import { assign } from '../../../../shared/Assign';
import FormValidationService from '../../../../shared/form/FormValidationService';
import ConfirmationModal from '../../../../components/common/ConfirmationModal';

class ImageProcessingDelivery extends React.Component<any, any> {
    constructor(props: any, context: any) {
        super(props, context);

        this.state = {
            deliveryMessage: null,
            deliveryDate: null,
            deliverOnlyToChecked: false,
            deliverOnlyToMail: null,
            deliverOnTime: false,
            informationUpdated: false,
            errors: {},
            showConfirmationModal: false,
            modalText: ''
        };

        this.onInputChange = this.onInputChange.bind(this);
        this.onDateChange = this.onDateChange.bind(this);
        this.deliverOrder = this.deliverOrder.bind(this);
        this.onCheckboxClick = this.onCheckboxClick.bind(this);
        this.updateDelivery = this.updateDelivery.bind(this);
        this.redeliverOrder = this.redeliverOrder.bind(this);
        this.overrideScheduledDelivery = this.overrideScheduledDelivery.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
    }

    UNSAFE_componentWillMount() {
        this.props.actions.getDeliveryStatusForOrder(this.props.orderId).catch(handleError);
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        if (nextProps.deliveryStatus && !this.state.informationUpdated) {
            let deliveryStatus = assign({}, nextProps.deliveryStatus);
            let state = assign({}, this.state);
            state.deliveryMessage = deliveryStatus.deliveryMessage;
            state.deliveryDate = moment(deliveryStatus.deliveryDate);
            state.deliverOnTime = deliveryStatus.deliveryDate ? true : false;
            state.deliverOnlyToMail = deliveryStatus.deliverOnlyToMail;
            state.deliverOnlyToChecked = deliveryStatus.deliverOnlyToMail ? true : false;
            this.setState(state);
        }
    }

    onInputChange(e: any) {
        let state = assign({}, this.state);
        state[e.target.name] = e.target.value;
        state.informationUpdated = true;
        this.setState(state);
    }

    onDateChange(moment: any) {
        let state = assign({}, this.state);
        state.deliveryDate = moment ? moment.toDate() : null;
        state.informationUpdated = true;
        this.setState(state);
    }

    onCheckboxClick(e: any) {
        let state = assign({}, this.state);
        state[e.target.name] = e.target.checked;
        state.informationUpdated = true;
        this.setState(state);
    }

    deliverOrder() {
        let deliverOnlyToMail = this.state.deliverOnlyToChecked
            ? this.state.deliverOnlyToMail
            : null;
        let deliveryDate = this.state.deliverOnTime ? this.state.deliveryDate : null;
        this.props.actions
            .deliverOrder(
                this.props.orderId,
                this.state.deliveryMessage,
                deliveryDate,
                deliverOnlyToMail
            )
            .then(() => {
                notify.success(Translate('image-processing/deliver/notification/delivery-saved'));
                this.setState({ informationUpdated: false });
            })
            .catch((error: any) =>
                handleError(error, (errors: any) => {
                    this.setState({ errors: errors });
                })
            );
    }

    updateDelivery() {
        let deliverOnlyToMail = this.state.deliverOnlyToChecked
            ? this.state.deliverOnlyToMail
            : null;
        let deliveryDate = this.state.deliverOnTime ? this.state.deliveryDate : null;
        this.props.actions
            .updateDelivery(
                this.props.orderId,
                this.state.deliveryMessage,
                deliveryDate,
                deliverOnlyToMail
            )
            .then(() => {
                notify.success(Translate('image-processing/deliver/notification/delivery-saved'));
                this.setState({ informationUpdated: false });
            })
            .catch((error: any) =>
                handleError(error, (errors: any) => {
                    this.setState({ errors: errors });
                })
            );
    }

    redeliverOrder() {
        this.props.actions
            .redeliverOrder(this.props.orderId)
            .then(() => {
                notify.success(Translate('image-processing/deliver/notification/redelivery-saved'));
                this.setState({ informationUpdated: false });
            })
            .catch((error: any) =>
                handleError(error, (errors: any) => {
                    this.setState({ errors: errors });
                })
            );
    }

    overrideScheduledDelivery() {
        this.props.actions
            .overrideScheduledDelivery(this.props.orderId)
            .then(() => {
                notify.success(
                    Translate('image-processing/deliver/notification/scheduled-delivery-overridden')
                );
                this.setState({ informationUpdated: false });
            })
            .catch((error: any) =>
                handleError(error, (errors: any) => {
                    this.setState({ errors: errors });
                })
            );
    }

    getConfirmModalText = (warningToManyImagesInfos: any[]) => {
        let warningTextAccept = Translate(
            'image-processing/deliver/panel/form/modal/warning-text/text-confirm' //Are you sure to deliver this order?
        );
        let imagesSingle = Translate(
            'image-processing/deliver/panel/form/modal/warning-text/image-single' //image
        );
        let imagesMultiple = Translate(
            'image-processing/deliver/panel/form/modal/warning-text/image-multiple' //images
        );

        let outerHTMLtext: any[] = [];

        warningToManyImagesInfos.forEach((x, id) => {
            if (x.extraImageSection) {
                const innerHTMLtext = (
                    <div key={id} className="order-row-header modal-delivery">
                        <span className="product-name">
                            <b>{x.packageName}</b>
                        </span>{' '}
                        <span className="number-of-images">{x.packageDescription}</span>
                        <div>{`Kund har köpt till ${x.boughtExtraImages} extrabilder.`}</div>
                        <div></div>
                    </div>
                );
                outerHTMLtext.push(innerHTMLtext);
            } else {
                let innerWarningText =
                    x.numberOfToManyImages < 1
                        ? Translate(
                              'image-processing/deliver/panel/form/modal/warning-text/text-to-few', //The order will be delivered with {numberOfImages} which is {numberOfToManyImages} fewer than described on the order row.
                              {
                                  numberOfImages: x.numberOfAddedPhotos,
                                  numberOfToManyImages:
                                      Math.abs(x.numberOfToManyImages) +
                                      ' ' +
                                      (Math.abs(x.numberOfToManyImages) > 1
                                          ? imagesMultiple
                                          : imagesSingle)
                              }
                          )
                        : Translate(
                              'image-processing/deliver/panel/form/modal/warning-text/text-to-many', //The order will be delivered with {numberOfImages} which is {numberOfToManyImages} more than described on the order row.
                              {
                                  numberOfImages: x.numberOfAddedPhotos,
                                  numberOfToManyImages:
                                      Math.abs(x.numberOfToManyImages) +
                                      ' ' +
                                      (Math.abs(x.numberOfToManyImages) > 1
                                          ? imagesMultiple
                                          : imagesSingle)
                              }
                          );
                const innerHTMLtext = (
                    <div key={id} className="order-row-header modal-delivery">
                        {x.packages.map((e, idx: number) => {
                            return (
                                <span>
                                    {idx > 0 ? ' + ' : ''}
                                    <span className="product-name">
                                        <b>{e.packageName}</b>
                                    </span>{' '}
                                    <span className="number-of-images">{e.packageDescription}</span>
                                </span>
                            );
                        })}
                        <div>{innerWarningText}</div>
                        <div></div>
                    </div>
                );

                outerHTMLtext.push(innerHTMLtext);
            }
        });

        outerHTMLtext.push(<div>{warningTextAccept}</div>);

        return <div>{outerHTMLtext}</div>;
    };

    toggleModal = () => {
        let toggleModal = !this.state.showConfirmationModal;
        let warningToManyImagesInfos: any[] = [];

        // This code calculates the total expected quantity of all non-uploadable items in the order
        let numberOfAdditionalImages =
            this.props.photoOrderInfo.orderRowQuantitiesInfo &&
            this.props.photoOrderInfo.orderRowQuantitiesInfo
                .filter((x) => x.isUploadable === 0)
                .map((x) => x.expectedQuantity)
                .reduce((sum, expectedQuantity) => sum + expectedQuantity, 0);

        this.props.photoOrderInfoEdited.forEach(photoOrderRowInfoEdited => {

            let photosInRow = this.props.photoOrderInfo.photosInRows.find((x) => x.orderRowId == photoOrderRowInfoEdited.id);

            let numberOfWantedPhotos = photoOrderRowInfoEdited.numberOfImages;
            let numberOfAddedPhotos = photosInRow ? photosInRow.numberOfAddedPhotos : 0;
            let numberOfTotalWantedPhotos = numberOfWantedPhotos + numberOfAdditionalImages;

            if (
                numberOfTotalWantedPhotos > 0 &&
                (numberOfAddedPhotos > numberOfTotalWantedPhotos ||
                 numberOfAddedPhotos < numberOfTotalWantedPhotos)
            ) {
                let packages = [
                    {
                        packageName: photoOrderRowInfoEdited.name,
                        packageDescription:
                            '(' +
                            Translate('unedited-images/number-of-images', {
                                numberOfImages: photoOrderRowInfoEdited.numberOfImages
                            }) +
                            ')'
                    }
                ];

                if (numberOfAdditionalImages > 0) {
                    this.props.photoOrderInfo.orderRowQuantitiesInfo
                        .filter((x) => x.isUploadable === 0)
                        .map((x) => {
                            packages.push({
                                packageName: x.productName,
                                packageDescription:
                                    '(' +
                                    Translate('unedited-images/number-of-images', {
                                        numberOfImages: x.expectedQuantity
                                    }) +
                                    ')'
                            });
                        });
                }

                let info = {
                    packages: packages,
                    numberOfWantedPhotos: numberOfTotalWantedPhotos,
                    numberOfAddedPhotos: numberOfAddedPhotos,
                    numberOfToManyImages: numberOfAddedPhotos - numberOfTotalWantedPhotos
                };

                warningToManyImagesInfos.push(info);
            }
            
            // Reset numberOfAdditionalImages after the first row (as they only apply to the first row)
            numberOfAdditionalImages = 0;
        });

        if (this.props.photoOrderInfo.boughtExtraImages > 0) {
            warningToManyImagesInfos.push({
                packageName: 'Extra',
                extraImageSection: true,
                boughtExtraImages: this.props.photoOrderInfo.boughtExtraImages
            });
        }

        if (warningToManyImagesInfos.length > 0) {
            this.setState({
                showConfirmationModal: toggleModal,
                modalText: this.getConfirmModalText(warningToManyImagesInfos)
            });
        } else {
            this.deliverOrder();
        }
    };

    render() {
        return (
            <div>
                {(this.props.photoStatus === PhotoStatus.EditorApproved ||
                    this.props.photoStatus === PhotoStatus.Se360Approved) &&
                    !(this.props.deliveryStatus.isDirectDelivery === true ||
                        this.props.deliveryStatus.delivered === true) && (
                    <Panel>
                        <Panel.Heading>
                            <Panel.Title>
                                {Translate('image-processing/deliver/panel/header/delivery')}
                            </Panel.Title>
                        </Panel.Heading>
                        <Panel.Body>
                            <Form>
                                <FormGroup>
                                    <ControlLabel>
                                        {Translate(
                                            'image-processing/deliver/panel/form/input-label/message-for-recipient'
                                        )}
                                    </ControlLabel>
                                    <FormControl
                                        disabled={
                                            this.props.deliveryStatus.isDirectDelivery ||
                                            this.props.deliveryStatus.delivered
                                        }
                                        name="deliveryMessage"
                                        componentClass="textarea"
                                        value={
                                            this.state.deliveryMessage
                                                ? this.state.deliveryMessage
                                                : ''
                                        }
                                        onChange={this.onInputChange}
                                    ></FormControl>
                                </FormGroup>
                                <FormGroup>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <Checkbox
                                                inline
                                                name="deliverOnTime"
                                                disabled={
                                                    this.props.deliveryStatus.isDirectDelivery ||
                                                    this.props.deliveryStatus.delivered
                                                }
                                                checked={this.state.deliverOnTime}
                                                onChange={this.onCheckboxClick}
                                            >
                                                <span>
                                                    {Translate(
                                                        'image-processing/deliver/panel/form/input-label/delivery-date'
                                                    )}
                                                </span>
                                            </Checkbox>
                                        </div>
                                        <div className="col-md-8">
                                            {this.state.deliverOnTime &&
                                                !this.props.deliveryStatus.delivered && (
                                                    <DateTime
                                                        locale={moment.locale()}
                                                        value={this.state.deliveryDate}
                                                        onChange={this.onDateChange}
                                                        isValidDate={(date) => {
                                                            return date.isAfter(
                                                                moment().subtract(1, 'day')
                                                            );
                                                        }}
                                                    />
                                                )}
                                            {this.state.deliverOnTime &&
                                                this.props.deliveryStatus.delivered && (
                                                    <span>{`${this.state.deliveryDate.toString()}`}</span>
                                                )}
                                        </div>
                                    </div>
                                </FormGroup>
                                <FormGroup
                                    validationState={FormValidationService.getValidationState(
                                        this.state.errors ? this.state.errors.deliverOnlyToMail : ''
                                    )}
                                >
                                    <div className="row">
                                        <div className="col-md-4">
                                            <Checkbox
                                                inline
                                                name="deliverOnlyToChecked"
                                                disabled={
                                                    this.props.deliveryStatus.isDirectDelivery ||
                                                    this.props.deliveryStatus.delivered
                                                }
                                                checked={this.state.deliverOnlyToChecked}
                                                onChange={this.onCheckboxClick}
                                            >
                                                <span>
                                                    {Translate(
                                                        'image-processing/deliver/panel/form/send-only-to'
                                                    )}
                                                </span>
                                            </Checkbox>
                                        </div>
                                        <div className="col-md-8">
                                            {this.state.deliverOnlyToChecked && (
                                                <FormControl
                                                    value={
                                                        this.state.deliverOnlyToMail
                                                            ? this.state.deliverOnlyToMail
                                                            : ''
                                                    }
                                                    disabled={
                                                        this.props.deliveryStatus.isDirectDelivery ||
                                                        this.props.deliveryStatus.delivered
                                                    }
                                                    name="deliverOnlyToMail"
                                                    type="email"
                                                    onChange={this.onInputChange}
                                                />
                                            )}
                                        </div>
                                    </div>
                                    {this.state.errors && (
                                        <HelpBlock>{this.state.errors.deliverOnlyToMail}</HelpBlock>
                                    )}
                                </FormGroup>
                                {this.props.photoStatus === PhotoStatus.EditorApproved && (
                                    <Button
                                        disabled={
                                            this.props.deliveryStatus.isDirectDelivery ||
                                            this.props.deliveryStatus.delivered
                                        }
                                        className="pull-right"
                                        data-testid="deliver-order"
                                        bsStyle="primary"
                                        onClick={this.toggleModal}
                                    >
                                        {Translate(
                                            'image-processing/deliver/panel/form/button-label/deliver'
                                        )}
                                    </Button>
                                )}
                                {this.props.photoStatus === PhotoStatus.Se360Approved &&
                                    !this.props.deliveryStatus.isDirectDelivery &&
                                    !this.props.deliveryStatus.delivered && (
                                        <Button
                                            disabled={
                                                this.props.deliveryStatus.isDirectDelivery ||
                                                this.props.deliveryStatus.delivered
                                            }
                                            className="pull-right"
                                            bsStyle="primary"
                                            onClick={this.updateDelivery}
                                        >
                                            {Translate(
                                                'image-processing/deliver/panel/form/button-label/update-delivery'
                                            )}
                                        </Button>
                                    )}
                            </Form>
                        </Panel.Body>
                    </Panel>
                )}
                {(this.props.photoStatus === PhotoStatus.CustomerApproved ||
                    this.props.photoStatus === PhotoStatus.DeliveryStarted ||
                    this.props.photoStatus === PhotoStatus.Delivered ||
                    this.props.photoStatus === PhotoStatus.DeliveryError) && (
                    <Panel>
                        <Panel.Heading>
                            <Panel.Title>
                                {Translate('image-processing/deliver/panel/header/redelivery')}
                            </Panel.Title>
                        </Panel.Heading>
                        <Panel.Body>
                            <Form>
                                <FormGroup>
                                    <ControlLabel>
                                        {Translate(
                                            'image-processing/deliver/panel/form/input-label/redeliver'
                                        )}
                                    </ControlLabel>
                                    <Button
                                        className="pull-right"
                                        bsStyle="primary"
                                        onClick={this.redeliverOrder}
                                    >
                                        {Translate(
                                            'image-processing/deliver/panel/form/button-label/redeliver'
                                        )}
                                    </Button>
                                </FormGroup>
                            </Form>
                        </Panel.Body>
                    </Panel>
                )}
                {this.props.photoStatus === PhotoStatus.ScheduledForCustomerApproval && (
                    <Panel>
                        <Panel.Heading>
                            <Panel.Body>
                                {Translate(
                                    'image-processing/deliver/panel/header/override-scheduled-delivery'
                                )}
                            </Panel.Body>
                        </Panel.Heading>
                        <Panel.Body>
                            <Form>
                                <FormGroup>
                                    <ControlLabel>
                                        {Translate(
                                            'image-processing/deliver/panel/form/input-label/override-scheduled-delivery'
                                        )}
                                    </ControlLabel>
                                    <Button
                                        className="pull-right"
                                        bsStyle="primary"
                                        onClick={this.overrideScheduledDelivery}
                                    >
                                        {Translate(
                                            'image-processing/deliver/panel/form/button-label/override-scheduled-delivery'
                                        )}
                                    </Button>
                                </FormGroup>
                            </Form>
                        </Panel.Body>
                    </Panel>
                )}
                {this.state.showConfirmationModal && (
                    <ConfirmationModal
                        {...{
                            extraValidation: false,
                            extraValidationText: ''
                        }}
                        closeModal={this.toggleModal}
                        title={Translate('image-processing/deliver/panel/form/modal/title/deliver')}
                        text={this.state.modalText}
                        doButtonLabel={Translate(
                            'image-processing/deliver/panel/form/modal/button-label/deliver'
                        )}
                        cancelButtonLabel={Translate(
                            'image-processing/deliver/panel/form/modal/button-label/cancel'
                        )}
                        doButtonStyle="success"
                        do={this.deliverOrder}
                        disableSubmit={false}
                        initialSubmitDisabling={false}
                        onCheckboxToggle={() => {}}
                        size={'medium'}
                        dialogClassName="modal-40w"
                    />
                )}
            </div>
        );
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        photoOrderInfo: state.imageProcessing.photoStatus,
        photoOrderInfoEdited: state.imageProcessing.edited.list,
        photoStatus: state.imageProcessing.photoStatus.currentStatus,
        deliveryStatus: state.imageProcessing.deliveryStatus
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            getDeliveryStatusForOrder: (orderId: number) =>
                dispatch(actions.getDeliveryStatusForOrder(orderId)),
            deliverOrder: (
                orderId: any,
                deliveryMessage: string,
                deliveryDate: Date,
                deliverOnlyToMail: string
            ) =>
                dispatch(
                    actions.deliverOrder(orderId, deliveryMessage, deliveryDate, deliverOnlyToMail)
                ),
            updateDelivery: (
                orderId: any,
                deliveryMessage: string,
                deliveryDate: Date,
                deliverOnlyToMail: string
            ) =>
                dispatch(
                    actions.updateDelivery(
                        orderId,
                        deliveryMessage,
                        deliveryDate,
                        deliverOnlyToMail
                    )
                ),
            redeliverOrder: (orderId: any) => dispatch(actions.redeliverOrder(orderId)),
            overrideScheduledDelivery: (orderId: any) =>
                dispatch(actions.overrideScheduledDelivery(orderId))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ImageProcessingDelivery);
